import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import axios from 'axios';
import router from '@/router';

const store = createStore({
  plugins: [
    createPersistedState()
  ],
  state: {
    statusUpdated: false,
    user: null,
    token: null,
    role: null,
    isAuthenticated: false,
    projectName: 'IT WORK WNH',
    projectNameTH: 'ภาระงานไอที',
    projectShortName: 'emt'
  },
  mutations: {
    setStatusUpdated(state, status) {
      state.statusUpdated = status;
    },

    SET_USER(state, user) {
      state.user = user;
      state.isAuthenticated = true;
    },
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_ROLE(state, role) {
      state.role = role;
    },
    CLEAR_AUTH(state) {
      state.user = null;
      state.token = null;
      state.role = null;
      state.isAuthenticated = false;
    },
  },
  actions: {
    updateStatus({ commit }, status) {
      commit('setStatusUpdated', status);
    },
    async login({ commit }, credentials) {
      try {
        await axios.get('sanctum/csrf-cookie');
        const response = await axios.post('/api/login', credentials);

        commit('SET_USER', response.data.user);
        commit('SET_TOKEN', response.data.token);
        commit('SET_ROLE', response.data.role);
        localStorage.setItem('token', response.data.token);

        // Use await correctly for router.push()
        await router.push({ name: 'Dashboard' }); // or use .then() as shown above
      } catch (error) {
        console.error('Login failed', error);
        throw new Error('Login failed');
      }
    },
    logout({ commit }) {
      commit('CLEAR_AUTH');
      localStorage.removeItem('role');
      localStorage.removeItem('token');
      localStorage.removeItem('vuex');
    },
    // Additional actions can be added here, like fetching user info
  },
  getters: {
    statusUpdated: (state) => state.statusUpdated,

    isAuthenticated: (state) => !!state.token,
    user: (state) => state.user,
    getProjectName: (state) => state.projectName,
    getProjectNameTH: (state) => state.projectNameTH,
    getProjectShortName: (state) => state.projectShortName
  },
});

export default store;
